<script lang="ts">
  export let totalOpportunities: number = 0;
  export let fullySynced: number = 0;
  export let syncInProgress: number = 0;
  export let conflicts: number = 0;
  export let errors: number = 0;

  export let onKpiClick: (status: string) => void = () => {};

  const handleClick = (status: string) => {
    onKpiClick(status);
  };

  const formatCount = (value: number) => Number.isFinite(value) ? value.toLocaleString() : "0";

  const icons = {
    cube: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16ZM3.27 6.96 12 12.01l8.73-5.05M12 22.08V12",
    check: "M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3",
    clock: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM12 6v6l4 2",
    warning: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0ZM12 9v4M12 17h.01",
    x: "M18 6 6 18M6 6l12 12",
  };

  $: cards = [
    {
      status: "all",
      label: "Total Opps",
      value: totalOpportunities,
      icon: icons.cube,
      cardClass: "border-white/20 bg-[linear-gradient(135deg,rgba(129,140,248,0.12)_0%,rgba(255,255,255,0.025)_100%)] hover:border-white/35 hover:shadow-[0_8px_24px_rgba(255,255,255,0.08)]",
      iconClass: "bg-indigo-500/20 text-indigo-400",
    },
    {
      status: "synced",
      label: "Fully Synced",
      value: fullySynced,
      icon: icons.check,
      cardClass: "border-green-500/60 bg-[linear-gradient(135deg,rgba(34,197,94,0.16)_0%,rgba(255,255,255,0.025)_100%)] hover:border-green-400 hover:shadow-[0_8px_24px_rgba(34,197,94,0.25)]",
      iconClass: "bg-green-500/25 text-green-300",
    },
    {
      status: "pending",
      label: "Pending",
      value: syncInProgress,
      icon: icons.clock,
      cardClass: "border-blue-500/60 bg-[linear-gradient(135deg,rgba(59,130,246,0.16)_0%,rgba(255,255,255,0.025)_100%)] hover:border-blue-400 hover:shadow-[0_8px_24px_rgba(59,130,246,0.25)]",
      iconClass: "bg-blue-500/25 text-blue-300",
    },
    {
      status: "conflict",
      label: "Conflicts",
      value: conflicts,
      icon: icons.warning,
      cardClass: "border-amber-500/60 bg-[linear-gradient(135deg,rgba(245,158,11,0.16)_0%,rgba(255,255,255,0.025)_100%)] hover:border-amber-400 hover:shadow-[0_8px_24px_rgba(245,158,11,0.25)]",
      iconClass: "bg-amber-500/25 text-amber-300",
    },
    {
      status: "error",
      label: "Errors",
      value: errors,
      icon: icons.x,
      cardClass: "border-red-500/60 bg-[linear-gradient(135deg,rgba(239,68,68,0.16)_0%,rgba(255,255,255,0.025)_100%)] hover:border-red-400 hover:shadow-[0_8px_24px_rgba(239,68,68,0.25)]",
      iconClass: "bg-red-500/25 text-red-300",
    },
  ];
</script>

<div class="mb-4 grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
  {#each cards as card}
    <div
      class="flex min-h-[98px] min-w-0 cursor-pointer items-center gap-4 rounded-lg border px-4 py-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] transition-all hover:-translate-y-1 sm:min-h-[112px] sm:gap-5 sm:px-5 sm:py-5 {card.cardClass}"
      on:click={() => handleClick(card.status)}
      on:keydown={(e) => e.key === "Enter" && handleClick(card.status)}
      role="button"
      tabindex="0"
    >
      <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl sm:h-14 sm:w-14 {card.iconClass}">
        <svg class="h-6 w-6 sm:h-7 sm:w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d={card.icon} stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="min-w-0">
        <div class="mb-1 text-[0.65rem] font-bold uppercase tracking-[1px] text-white/60 sm:text-[0.688rem]">
          {card.label}
        </div>
        <div class="text-[1.75rem] font-extrabold leading-none text-white sm:text-[2rem]">
          {formatCount(card.value)}
        </div>
      </div>
    </div>
  {/each}
</div>
